var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"text-danger"},[_c('i',{staticClass:"fa fa-ban fa-lg icon-button",attrs:{"title":"Reprovar"},on:{"click":function($event){$event.stopPropagation();return _vm.confirmarReprovacao()}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }